import DataTable from "datatables.net";
import 'datatables.net-bs5';
import * as Highcharts from "highcharts";
import {get, on, reset_choices, select_choices} from "./util";
import { getChartTheme } from './utils/chartTheme';
import {crafting_link, nwdb_link, update_motes} from "./nw/util";
import prices from "./nw/prices";
import crafting from "./nw/crafting";
import trades from "./nw/trades";
import mutations from "./nw/mutations";
import {Order} from "datatables.net-bs5";

declare const nw_item : {
    dates_array : string[],
    prices_array : any[],
    buy_orders_array : any[],
    interval : number
};

export default class {
    static init = () => {
        motes();
        item();
        groups();
        prices.init();
        crafting.init();
        trades.init();
        mutations.init();
    }
}

function motes() {
    on('keyup','.js-mote-amount', update_motes);
}

function item() {
    if(typeof nw_item !== 'undefined') {
        Highcharts.chart("chart_price_history", Highcharts.merge(getChartTheme(), {
            series: [{
                name: 'Price',
                data: nw_item.prices_array,
                color: '#3edc90'
            }/*,{
                name: 'Buy Order',
                data: nw_item.buy_orders_array,
                color: '#006bfd'
            }*/] as Highcharts.SeriesOptionsType[],
            chart: {
                type: 'spline',
                height: 400
            },
            title: {
                text: 'Price History',
                // align: 'left',
                style: {
                    fontSize: '14px'
                }
            },
            legend: {
                enabled: true,
            },
            xAxis: {
                type: 'datetime',
                labels: {
                    overflow: 'justify',
                },
            },
            // @ts-ignore
            yAxis: {
                title: {
                    text: '',
                },
                minorGridLineWidth: 0,
                gridLineWidth: 0,
                alternateGridColor: null,
            },
            tooltip: {
                valueSuffix: ' gold',
                xDateFormat: '%b %e, %Y'
            },
            plotOptions: {
                spline: {
                    lineWidth: 4,
                    states: {
                        hover: {
                            lineWidth: 5
                        }
                    },
                    marker: {
                        enabled: false
                    },
                    pointInterval: nw_item.interval,
                    pointStart: Date.parse(nw_item.dates_array[0]),
                }
            },
            credits: {
                enabled: false
            }
        }), () => {

        });

        // setTimeout(function() {
        //     // @ts-ignore
        //     let height = document.querySelector('iframe').contentWindow.innerHeight;
        //     console.log(height);
        // }, 2000);

        on('change','.js-items',(target : HTMLInputElement) => {
            let id = parseInt(target.value ?? "0");
            if(isNaN(id)) {
                id = 0;
            }
            window.location.href = '/nw/item/' + id;
        });
    }
}

function groups() {
    let table = document.querySelector('.datatable[data-table="nw_groups"]') as HTMLElement;
    if(!table) {
        return;
    }

    let datatable = new DataTable('.datatable[data-table="nw_groups"]',{
        pageLength: 10,
        lengthMenu: [10,20,50,100],
        processing: true,
        serverSide: true,
        ajax: {
            url: '?do=getGroups'
        },
        columns: [
            { data: null, className: "align-middle", render: function (data, type, row) {
                return `<span class="link text-decoration-none js-group-fill" data-id="${data.id}">${data.name.replaceAll(' ','&nbsp;')}</span>`;
            }},
            { data: null, className: "align-middle", render: function (data, type, row) {
                let items : string[] = [];
                data.items.forEach((item : any) => {
                    items.push(`<a href="/nw/item/${item.id}" class="text-decoration-none">${item.name.replaceAll(' ','&nbsp;')}</a>` + crafting_link(item.crafting_id) + nwdb_link(item.nw_id));
                });
                return items.join(', ');
            }},
        ],
        order: [[0,"asc"]] as Order[]
    });

    on('click','.js-group-fill',(target : HTMLElement) => {
        let name = target.innerText;
        let id = parseInt(target.getAttribute('data-id') ?? "0");
        if(id) {
            get('?do=getGroupItems', {nw_groups_id: id},(data : any) => {
                if(data) {
                    (document.querySelector('[name="id"]') as HTMLInputElement).value = id.toString();
                    (document.querySelector('[name="name"]') as HTMLInputElement).value = name;
                    let items = document.querySelector('[name="items[]"]') as HTMLSelectElement;
                    reset_choices(items);
                    select_choices(items, data);
                }
            });
        }
    },true);
}
